/** 平台展示名：去首尾空格后 1–128，与创建接口上限一致 */
export const APP_NAME_MAX = 128

/** 小写字母开头，仅小写字母、数字、短横线，总长 2–32 */
export const APP_ID_PATTERN = /^[a-z][a-z0-9-]{1,31}$/

export function isAppNameValid(name: string): boolean {
  const trimmed = name.trim()
  return trimmed.length >= 1 && trimmed.length <= APP_NAME_MAX
}

export function isAppIdValid(appId: string): boolean {
  return APP_ID_PATTERN.test(appId.trim())
}

export function canSubmitCreateApp(input: {
  name: string
  appId: string
  agreed: boolean
}): boolean {
  return isAppNameValid(input.name) && isAppIdValid(input.appId) && input.agreed
}
